import { getModuleFederatedName, setupServiceInfo, root } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import { CART_SIDEBAR_CART_OFFERS, CART_SIDEBAR_OFFERS_TAB, CART_SIDEBAR_OFFER_CODE_MODULE } from '@estee/elc-service-view-names';
import { serviceQueries } from '@estee/elc-service-bus';
import { defaultConfigs } from '~sharedComponents/ExternalReference/common/defaults/configs';
import { OffersService, serviceNames } from './OffersService';
import { serviceBusBaseClass } from './ServiceBus';

import '~exported/offer-code-module/vulcan';
import '~exported/cart-sidebar-cart-offers/vulcan';
import '~exported/samples-component/vulcan';
import '~exported/cart-sidebar-offers-tab/vulcan';

import '~setup/vulcan/serviceBus';

const emptyDefaultConfig = {
    cart: {},
    perlgem: {},
    stardust: {}
};

function mockEcommConfig() {
    // @ts-ignore
    const { cart, perlgem, stardust } = window?.site?.config || emptyDefaultConfig;
    // @ts-ignore
    const serviceConfig = { ...defaultConfigs, ...cart, perlgem, stardust };

    try {
        root.GlobalServiceBus.registerQueryProvider(
            serviceQueries.GET_CONFIG, () => ({ ecommConfig: serviceConfig })
        );
    } catch (e) {
        console.warn(e);
    }
}

mockEcommConfig();

setupServiceInfo(__serviceInfo__);
const { name, version } = __serviceInfo__;

OffersService.setViews(name, getModuleFederatedName(name), version, [
    CART_SIDEBAR_CART_OFFERS,
    CART_SIDEBAR_OFFERS_TAB,
    CART_SIDEBAR_OFFER_CODE_MODULE,
    'samplesComponent'
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('./diContainer'),
    serviceKey: serviceNames.offersService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: {
        serviceBusBaseClass
    }
});
